import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Gift } from 'lucide-react';
import { useState } from 'react';
import { HolidayLeadForm } from './HolidayLeadForm';

export const HolidayHero = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <section
      className="relative min-h-screen bg-[linear-gradient(180deg,#0B2240_0%,#07182F_100%)] text-white overflow-hidden"
      data-testid="holiday-hero-section"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#D4AF37] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#1FA3A3] rounded-full blur-3xl"></div>
      </div>

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          {/* Headline */}
          <div className="flex justify-center mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#D4AF37]/10 border border-[#D4AF37]/20">
              <Gift className="w-8 h-8 text-[#D4AF37]" />
            </div>
          </div>

          <h1
            className="font-['Playfair_Display'] text-4xl sm:text-5xl lg:text-6xl font-semibold mb-6 tracking-tight"
            data-testid="holiday-headline"
          >
            Enter to Win a $1,000 Holiday Visa® Gift Card 🎁
          </h1>

          <p
            className="text-lg sm:text-xl text-white/80 max-w-3xl mx-auto mb-6 leading-relaxed"
            data-testid="holiday-subheadline"
          >
            Just fill out the Holiday Bonus Form below for your chance to win $1,000 toward holiday expenses — and get our 1-Page Holiday Money-Saver Kit to help you keep more of your hard-earned money this season.
          </p>

          {/* Trust note */}
          <p className="text-sm text-white/60 mb-8 max-w-2xl mx-auto">
            Open to U.S. residents age 18+. One entry per person. No purchase necessary. Winner will be selected by random drawing on or before December 12, 2025 and notified by email.
          </p>

          {/* CTA Button (Step 1) */}
          {!showForm && (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Button
                onClick={() => setShowForm(true)}
                className="h-14 px-10 text-lg rounded-xl bg-[linear-gradient(180deg,#E8D89E_0%,#D4AF37_50%,#B99610_100%)] text-[#0B2240] hover:brightness-95 shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] focus-visible:ring-2 focus-visible:ring-[#D4AF37] font-semibold"
                data-testid="holiday-cta-button"
              >
                Enter Now + Get Your Kit
              </Button>
            </motion.div>
          )}

          {/* Form (Step 2) */}
          {showForm && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="mt-10"
            >
              <HolidayLeadForm />
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>
  );
};
